"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var spinner_1 = __importDefault(require("../utils/spinner"));
var common_config_1 = __importDefault(require("../../common.config"));
var axios_1 = __importDefault(require("axios"));
var state_1 = __importDefault(require("../state/state"));
var renderMyFavorite_1 = __importDefault(require("./renderMyFavorite"));
var chooseSectionRender_1 = __importDefault(require("../chooseSection/chooseSectionRender"));
var generateName_1 = require("../titleSection/generateName");
var renderSizeInfo_1 = __importDefault(require("../customSection/renderSizeInfo"));
var renderSelectedItem_1 = require("../customSection/renderSelectedItem");
var carouselState_1 = require("../state/carouselState");
var generateId_1 = __importDefault(require("../utils/generateId"));
var $mywayBtn = document.querySelector('.myway-btn');
var $titleInput = document.querySelector('.title__input');
var $calcNumber = document.querySelector('.calc__number');
exports.default = (function () {
    $mywayBtn.addEventListener('click', function () { return __awaiter(void 0, void 0, void 0, function () {
        var $addBtnPopup_1, myFavoriteList, _a, _b, _c, _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    spinner_1.default.display();
                    if (!state_1.default.selectedItem.find(function (item) { return /meats/.test(item.id); })
                        || !state_1.default.selectedItem.find(function (item) { return /bread/.test(item.id); })) {
                        $addBtnPopup_1 = document.querySelector('.myway-btn__alertPopup');
                        $addBtnPopup_1.classList.add('active');
                        $addBtnPopup_1.addEventListener('animationend', function () {
                            $addBtnPopup_1.classList.remove('active');
                        });
                        spinner_1.default.hide();
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, axios_1.default.get(common_config_1.default.SERVER_URL + '/myFavorite')];
                case 1:
                    myFavoriteList = (_e.sent()).data;
                    _a = state_1.default;
                    if (!(state_1.default.id === null)) return [3 /*break*/, 3];
                    return [4 /*yield*/, (0, generateId_1.default)()];
                case 2:
                    _b = _e.sent();
                    return [3 /*break*/, 4];
                case 3:
                    _b = state_1.default.id;
                    _e.label = 4;
                case 4:
                    _a.id = _b;
                    _c = state_1.default;
                    if (!(state_1.default.name === null)) return [3 /*break*/, 6];
                    return [4 /*yield*/, myFavoriteList.name];
                case 5:
                    _d = _e.sent();
                    return [3 /*break*/, 7];
                case 6:
                    _d = state_1.default.name;
                    _e.label = 7;
                case 7:
                    _c.name = _d;
                    return [4 /*yield*/, axios_1.default.post(common_config_1.default.SERVER_URL + '/myFavorite', {
                            id: state_1.default.id,
                            name: $titleInput.value,
                            item: state_1.default.selectedItem,
                            calories: $calcNumber.textContent
                        })
                        // state 초기화
                    ];
                case 8:
                    _e.sent();
                    // state 초기화
                    state_1.default.id = null;
                    state_1.default.name = null;
                    $calcNumber.textContent = 0 + '';
                    state_1.default.selectedItem = [];
                    return [4 /*yield*/, (0, renderMyFavorite_1.default)()];
                case 9:
                    _e.sent();
                    return [4 /*yield*/, (0, chooseSectionRender_1.default)()];
                case 10:
                    _e.sent();
                    return [4 /*yield*/, (0, generateName_1.generateName)()];
                case 11:
                    _e.sent();
                    return [4 /*yield*/, (0, carouselState_1.getNumOfSlides)()];
                case 12:
                    _e.sent();
                    (0, renderSizeInfo_1.default)();
                    (0, renderSelectedItem_1.renderBreadName)();
                    (0, renderSelectedItem_1.renderMeatsName)();
                    (0, renderSelectedItem_1.renderDynamicList)();
                    spinner_1.default.hide();
                    return [2 /*return*/];
            }
        });
    }); });
});
